<template>
  <div class="app-container">
    <div class="materialFormLine">广宣物料增加入库</div>
    <div class="budgetBox">
      <a-form-model ref="materialForm" class="UniformCss" :inline="true" :model="material" :rules="rules" label-width="100px">
        <a-row>
          <a-col :span="6">
            <a-form-model-item label="物料号" prop="materialCode">
              <a-input v-model="material.materialCode" :disabled="true" />
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item label="物料名称" prop="materialName">
              <a-input v-model="material.materialName" :disabled="true" />
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item label="现有库存" prop="storage">
              <a-input v-model="material.storage" :disabled="true" />
            </a-form-model-item>
          </a-col>
                    <!-- lr0016 -->
          <!-- <a-col :span="6">
            <a-form-model-item label="供应商" prop="supplier">
              <a-input v-model="material.supplier" />
            </a-form-model-item>
          </a-col> -->
          <a-col :span="6">
            <a-form-model-item label="增加数量" prop="nums">
              <a-input v-model="material.nums" />
            </a-form-model-item>
          </a-col>
          <!-- <a-col :span="6">
            <a-form-model-item label="备注" prop="remark">
              <a-textarea v-model="material.remark" :rows="1.5" />
            </a-form-model-item>
          </a-col> -->
        </a-row>
      </a-form-model>
      <div class="btn-box">
        <vxe-button  @click="returnFun()">返回</vxe-button>
        <vxe-button status="primary" @click="saveMaterialInfo('materialForm')">保存</vxe-button>
      </div>
    </div>
  </div>
</template>
<script>
import { getMaterialById, updateInMaterial } from '@/api/material'
export default {
  name: 'AddInWarehouse',
  data() {
    return {
      material: {},
      rules: {
        supplier: [{ required: true, message: '请输入供应商', trigger: 'blur' }],
        nums: [{ required: true, message: '请输入预增数量', trigger: 'blur' }]
      }
    }
  },
  created() {
    this.material.id = this.$route.params.id
    if (this.$route.params.id) {
      this.getMaterialDetail()
    }
  },
  methods: {
    getMaterialDetail() {
      const id = this.material.id
      getMaterialById(id).then(res => {
        if (res.code === 1) {
          this.material = res.data.material
        } else {
          this.$message.error(res.message)
        }
      })
    },
    saveMaterialInfo() {
      this.$refs.materialForm.validate((valid) => {
        if (valid) {
          updateInMaterial(this.material).then(res => {
            if (res.code === 1) {
              this.$message.success('保存成功')
              // this.deleteRouter()
              this.returnListFun()
            } else {
              this.$message.error(res.message)
            }
          })
        } else {
          this.$message.error('请完善相关信息!')
          return false
        }
      })
    },
    returnFun() {
      // this.deleteRouter()
      this.returnListFun()
    },
    returnListFun() {
      // 跳转路由
      this.$closePage('/publicizeMaterialManagement/addInWarehouse', '/publicizeMaterialManagement/publicizeMaterialMaintenance')
    },
    // deleteRouter() {
    //   // 删除上个标签页
    //   this.$closePage('/publicizeMaterialManagement/addInWarehouse', '/publicizeMaterialManagement/PublicizeMaterialMaintenance')
    // }
  }
}
</script>

<style lang="less">
.budgetBox {
  .UniformCss {
    min-height: 280px;
  }
}
.materialFormLine {
  margin: 0;
  padding: 0px 20px;
  width: 100%;
  background: #0a76a4;
  color: #ffffff;
  height: 30px;
  line-height: 30px;
}
.btn-box {
  margin-top: 40px;
  display: flex;
  justify-content: center;
}
</style>
